import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
    display: 'grid',
    gridTemplateColumns: '4fr 1fr',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    paddingBottom: 0,

    paddingTop: 30
  },
  selectBoxes: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  oneBoxInRow: {
    marginBottom: 12,
    marginLeft: 40,
    marginRight: 117,
    '& div': {
      '& label': {
        paddingLeft: 0
      }
    }
  },
  twoBoxInRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 40,
    gap: 64,
    marginBottom: 12,
    marginRight: 117,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0
    },
    [theme.breakpoints.between(960, 1115)]: {
      flexDirection: 'column',
      gap: 0
    }
  },
  datePickerContainer: {
    backgroundColor: 'transparent',
    marginRight: 57,
    width: 282,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: '-18px',
    [theme.breakpoints.between(960, 1115)]: {
      marginTop: '-21px'
    }
  },
  buttonOfDate: {
    width: 282,
    height: 50,
    textAlign: 'left',
    '& span': {
      margin: '12px 0px',
      fontSize: 14
    }
  },
  dateRangePicker: {
    position: 'absolute',
    right: -2,
    top: -8,
    zIndex: 1
  },
  textShowOnButtonParrent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textShowOnButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginLeft: -48
  },
  textShowOnButtonAfterClickOnTimePeriodButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginBottom: -16,
    marginLeft: -48,
    '& p:last-child': {
      marginLeft: 12
    }
  },
  textShowOnButtonAfterSelectDateForArrivalDateAndDeparture: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: -8,
    '& p': {
      color: `${theme.palette.grey[100]} !important`
    },
    '& p:last-child': {
      marginLeft: 20
    }
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },
  arrowIcon: {
    marginBottom: '0px !important',
    marginLeft: '20px !important'
  },
  ButtonsContainer: {
    marginTop: 236,

    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    '& Button:first-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[700]}`
    },
    '& Button:last-child': {
      minHeight: 38,
      width: 116,
      fontSize: 16,
      color: `${theme.palette.grey[200]}`
    },
    [theme.breakpoints.between(960, 1115)]: {
      marginTop: 328
    }
  },
  applyText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 700
  },
  resetText: {
    fontWeight: 700
  }
}))

export default useStyles
